import type { ValidationRule } from "./validators";

// Shared by every signup form (patient, clinician) so the rules and their
// messages can't drift apart. Mirrors the backend's signup password check.
export const SIGNUP_PASSWORD_RULES: ValidationRule[] = [
  { required: true, message: "Password is required" },
  { min: 6, message: "Password must be at least 6 characters" },
];

export const CONFIRM_PASSWORD_RULES: ValidationRule[] = [{ required: true, message: "Please confirm your password" }];

export const PASSWORD_MISMATCH_MESSAGE = "Passwords do not match.";
